firebird.factory('pollingService', [
    '$rootScope',
    '$window',
    'attendeeService',
    'logService',
    'socketService',
    'brandingService',
    'localizationService',
    function ($rootScope, $window, attendeeService, logService, socketService, brandingService, localizationService) {
        const logger = logService.createLoggerWithSource('pollingService');
        var activePoll,
            activePollVotesPrivacyOptionId,
            getActivePollIsInitialized = false,
            service = {
                addNewPoll: addNewPoll,
                closePolling: closePolling,
                deleteExistingPoll: deleteExistingPoll,
                setVotingPrivacy: setVotingPrivacy,
                startVoting: startVoting,
                stopVoting: stopVoting,
                updateExistingPoll: updateExistingPoll,
                vote: vote,
                getActivePoll: getActivePoll,
                getIsVoting: getIsVoting
            };

        $rootScope.$on('voting-stopped', onVotingStopped);
        $rootScope.$on('voting-started', onVotingStarted);

        $rootScope.$on('votes-update', onVotesUpdate);
        $rootScope.$on('votes-privacy-update', onVotesPrivacyUpdate);

        return service;

        ////////////////////////

        function addNewPoll(pollTopic, pollOption1, pollOption2, pollOption3, pollOption4, pollOption5) {
            logger.log(
                'addNewPoll - pollTopic: ' +
                    pollTopic +
                    ', pollOption1: ' +
                    pollOption1 +
                    ', pollOption2: ' +
                    pollOption2 +
                    ', pollOption3: ' +
                    pollOption3 +
                    ', pollOption4: ' +
                    pollOption4 +
                    ', pollOption5: ' +
                    pollOption5
            );
            var msgObj = {
                message: 'create-poll',
                data: {
                    pollTopic: pollTopic || '',
                    pollOption1: pollOption1 || '',
                    pollOption2: pollOption2 || '',
                    pollOption3: pollOption3 || '',
                    pollOption4: pollOption4 || '',
                    pollOption5: pollOption5 || ''
                },
                callback: function (returnData) {
                    if (returnData && returnData.pollId && parseInt(returnData.pollId) > 0) {
                        // Broadast 'new-poll-added'
                        $rootScope.$broadcast('new-poll-added');

                        $window.swal({
                            title: localizationService.translate('POLLS.POLL_ADDED.TITLE'),
                            text: localizationService.translate('POLLS.POLL_ADDED.TEXT'),
                            type: 'success',
                            confirmButtonColor: brandingService.getBaseColor(),
                            timer: 2000
                        });
                    } else {
                        // Something else happened :(
                    }
                }
            };

            socketService.send(msgObj);
        }

        function closePolling() {
            logger.log('closePolling');
            var msgObj = {
                message: 'close-polling',
                data: {},
                callback: function (returnData) {
                    // Nothing to do here
                }
            };
            socketService.send(msgObj);
        }

        function deleteExistingPoll(pollId) {
            logger.log('deleteExistingPoll - pollId: ' + pollId);
            var msgObj = {
                message: 'delete-poll',
                data: pollId,
                callback: function (returnData) {
                    // Broadast 'existing-poll-deleted'
                    $rootScope.$broadcast('existing-poll-deleted');

                    $window.swal({
                        title: localizationService.translate('POLLS.POLL_DELETED.TITLE'),
                        text: localizationService.translate('POLLS.POLL_DELETED.TEXT'),
                        confirmButtonColor: brandingService.getBaseColor(),
                        type: 'success'
                    });
                }
            };
            socketService.send(msgObj);
        }

        function getActivePoll() {
            if (!getActivePollIsInitialized) {
                var self = this;

                var msgObj = {
                    message: 'get-active-poll',
                    data: {},
                    callback: function (newActivePoll, votingPrivacyId) {
                        activePoll = newActivePoll;

                        if (service.getIsVoting()) {
                            $rootScope.$broadcast('voting-started');
                            $rootScope.$broadcast('votes-privacy-update', votingPrivacyId);
                        }
                    }
                };

                socketService.send(msgObj);
                getActivePollIsInitialized = true;
            } else {
                return activePoll;
            }
        }

        function getIsVoting() {
            return activePoll ? true : false;
        }

        function setVotingPrivacy(data) {
            if (attendeeService.getIsPresenter()) {
                var self = this;

                var msgObj = {
                    message: 'set-voting-privacy',
                    data: data
                };
                socketService.send(msgObj);
            }
        }

        function startVoting(attendantLoginId, pollId, pollsIndex) {
            logger.log(
                'startVoting - attendantLoginId: ' +
                    attendantLoginId +
                    ', pollId: ' +
                    pollId +
                    ', pollsIndex: ' +
                    pollsIndex
            );
            var msgObj = {
                message: 'start-voting',
                data: {
                    attendantLoginId: attendantLoginId,
                    pollId: pollId,
                    pollsIndex: pollsIndex
                },
                callback: function (returnData) {
                    // Nothing to do here
                }
            };
            socketService.send(msgObj);
        }

        function stopVoting(attendantLoginId) {
            logger.log('stopVoting - attendantLoginId: ' + attendantLoginId);
            var msgObj = {
                message: 'stop-voting',
                data: {
                    attendantLoginId: attendantLoginId
                },
                callback: function (returnData) {
                    // Nothing to do here
                }
            };
            socketService.send(msgObj);
        }

        function updateExistingPoll(
            pollId,
            pollTopic,
            pollOption1,
            pollOption2,
            pollOption3,
            pollOption4,
            pollOption5
        ) {
            logger.log(
                'updateExistingPoll - pollId: ' +
                    pollId +
                    ', pollTopic: ' +
                    pollTopic +
                    ', pollOption1: ' +
                    pollOption1 +
                    ', pollOption2: ' +
                    pollOption2 +
                    ', pollOption3: ' +
                    pollOption3 +
                    ', pollOption4: ' +
                    pollOption4 +
                    ', pollOption5: ' +
                    pollOption5
            );
            var msgObj = {
                message: 'edit-poll',
                data: {
                    pollId: pollId,
                    pollTopic: pollTopic || '',
                    pollOption1: pollOption1 || '',
                    pollOption2: pollOption2 || '',
                    pollOption3: pollOption3 || '',
                    pollOption4: pollOption4 || '',
                    pollOption5: pollOption5 || ''
                },
                callback: function (returnData) {
                    if (returnData && returnData.pollId && parseInt(returnData.pollId) > 0) {
                        // Broadast 'existing-poll-updated'
                        $rootScope.$broadcast('existing-poll-updated');

                        $window.swal({
                            title: localizationService.translate('POLLS.POLL_UPDATED.TITLE'),
                            text: localizationService.translate('POLLS.POLL_UPDATED.TEXT'),
                            type: 'success',
                            confirmButtonColor: brandingService.getBaseColor(),
                            timer: 2000
                        });
                    } else {
                        // Something else happened :(
                    }
                }
            };
            socketService.send(msgObj);
        }

        function vote(attendantLoginId, voteIndex) {
            logger.log('vote - attendantLoginId: ' + attendantLoginId + ', voteIndex: ' + voteIndex);
            var msgObj = {
                message: 'vote-on-poll',
                data: {
                    attendantId: attendeeService.getAttendantId(),
                    attendantLoginId: attendantLoginId,
                    voteIndex: voteIndex
                },
                callback: function (returnData) {
                    // Nothing to do here
                }
            };
            socketService.send(msgObj);
        }

        ////////////////////////
        // Event handlers

        function onVotingStopped(event) {
            activePoll = undefined;
        }

        function onVotingStarted(event, newActivePoll) {
            if (newActivePoll) {
                activePoll = newActivePoll;
            }
        }

        function onVotesUpdate(event, newActivePollUpdate) {
            if (activePoll !== undefined) {
                activePoll.totalVotes = newActivePollUpdate[0];
                activePoll.options[0].votes = newActivePollUpdate[1];
                activePoll.options[1].votes = newActivePollUpdate[2];
                activePoll.options[2].votes = newActivePollUpdate[3];
                activePoll.options[3].votes = newActivePollUpdate[4];
                activePoll.options[4].votes = newActivePollUpdate[5];
            }
        }

        function onVotesPrivacyUpdate(event, optionId) {
            activePollVotesPrivacyOptionId = optionId;
        }
    }
]);
